import { useIntl } from '@capsicum/common';
import { Skeleton, SkeletonItem } from '@capsicum/common-web';
import styled from 'styled-components';

import type { NetworkCardItem } from './NetworkSelectionListCard';

export type NetworkMinimumProps = {
	item: NetworkCardItem;
};

export const NetworkMinimum = ({ item: { isMinAmountLoading, minAmount } }: NetworkMinimumProps) => {
	const { $t } = useIntl();

	if (isMinAmountLoading) {
		return (
			<Skeleton>
				<S.MinimumSkeletonItem />
			</Skeleton>
		);
	}

	if (minAmount && Number(minAmount) !== 0) {
		return $t('wallet.withdraw.networks.min', { min: minAmount });
	}

	return $t('wallet.receive.selectNetwork.minAmount');
};

namespace S {
	export const MinimumSkeletonItem = styled(SkeletonItem)`
		${({ theme }) => theme.fonts.text.text5};
		width: 200px;
	`;
}
